import {
  Checkbox,
  formatDate,
  formatMinutes,
  ListMenu,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  UpdateIconButton,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StaffServiceListDto,
  StaffServiceListResource,
} from "generated/openApi";

import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { staffServicePageRoute } from "../StaffServicePage/StaffServicePage";
import { useStaffServiceListMenuItems } from "./useStaffServiceListMenuItems";

export const StaffServiceTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  staffServices: StaffServiceListDto[];
  listTotal: number | undefined;
  resource: StaffServiceListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];
  const menuItems = useStaffServiceListMenuItems({
    permission: props.rootPermission,
    setSelectedIds: props.setSelectedIds,
    loadList: props.loadList,
  });

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {menuItems.length > 0 && (
              <TableCell type="select">
                <ListMenu
                  selectedIds={props.selectedIds}
                  setSelectedIds={props.setSelectedIds}
                  listTotal={props.listTotal}
                  fetchFunction={() => props.getIdsPromise()}
                  actionMenuItems={menuItems}
                />
              </TableCell>
            )}
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("date"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("staff"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("serviceType"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("serviceName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("durationInMinutes"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell align="right">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceListDto>("files"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.staffServices.map((staffServiceItem) => (
            <TableRow
              key={staffServiceItem.id}
              onClick={() =>
                navigate(
                  staffServicePageRoute.getPath({
                    id: staffServiceItem.id,
                    crudMode: "view",
                    screenType: "standard",
                  })
                )
              }
            >
              {menuItems.length > 0 && (
                <TableCell type="select">
                  <Checkbox
                    checked={props.selectedIds.includes(staffServiceItem.id)}
                    onClick={(e) => props.selectId(staffServiceItem.id)}
                  />
                </TableCell>
              )}
              <TableCell>{formatDate(staffServiceItem.date)}</TableCell>
              <TableCell>{staffServiceItem.staff}</TableCell>
              <TableCell>{staffServiceItem.serviceType}</TableCell>
              <TableCell>{staffServiceItem.serviceName}</TableCell>

              <TableCell>{formatMinutes(staffServiceItem.durationInMinutes)}</TableCell>
              <TableCell align="right">{staffServiceItem.files > 0 && staffServiceItem.files}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate(
                        staffServicePageRoute.getPath({
                          id: staffServiceItem.id,
                          crudMode: "edit",
                          screenType: "standard",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
